import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Motivation } from 'shared/components/Motivation';
import { selectPlatform } from 'shared/selectors/platform';

import { trackButtonClick } from './tracking';

interface IMotivationContainerProps {
  isBottom?: boolean;
}

export const MotivationContainer: FC<IMotivationContainerProps> = ({ isBottom }) => {
  const platform = useSelector(selectPlatform);

  const handleClick = useCallback((buttonName: string) => trackButtonClick(platform, buttonName), [platform]);

  return <Motivation isBottom={isBottom} platform={platform} onClick={handleClick} />;
};
